import { render } from "./AddPickup.vue?vue&type=template&id=311870ba&scoped=true"
import script from "./AddPickup.vue?vue&type=script&lang=js"
export * from "./AddPickup.vue?vue&type=script&lang=js"

import "./AddPickup.vue?vue&type=style&index=0&id=311870ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311870ba"]])

export default __exports__